import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, vShow as _vShow, toDisplayString as _toDisplayString, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3b162d8a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "TProjetos",
  "data-testid": "TProjetos"
}
const _hoisted_2 = { class: "TProjetos__Cabecalho" }
const _hoisted_3 = {
  key: 0,
  class: "Tprojetos__Botoes"
}
const _hoisted_4 = { class: "TProjetos__Conteudo" }
const _hoisted_5 = {
  class: "TProjetos__Tabela",
  "data-testid": "TProjetos__TabelaDeProjetos"
}
const _hoisted_6 = { class: "ModalDeAlerta__Texto" }
const _hoisted_7 = { class: "ModalDeAlerta__Botoes" }

import { MenuItem } from "primevue/menuitem"
  import { useRouter } from "vue-router"
  import {
    OTabelaProjetos,
    MListaDeGrupos,
    MCabecalhoTabelaGrupo,
    OEditarGrupos,
  } from ".."
  import { MModalDeAlerta, OTrilhaDeNavegacao } from "@/components/Gerais"
  import { ComputedRef, computed, onMounted, reactive, ref, watch } from "vue"
  import GruposDeProjetosRepositorio from "@/repositorios/gruposDeProjetos/gruposDeProjetos.repositorio"
  import {
    GrupoDeProjetos,
    ListarGruposDeProjetos,
    ParametrosGruposDeProjetos,
  } from "@/repositorios/gruposDeProjetos/gruposDeProjetos.modelo"
  import { usarLeitorDeDados } from "@/composable/UsarLeitorDeDados/usarLeitorDeDados"
  import { usarBuscarMaisDados } from "@/composable/UsarBuscarMaisDados/usarBuscarMaisDados"
  import SessaoServico from "@/servicos/sessao.service"
  import {
    Anulavel,
    EntidadeSimples,
    PerfilDeOrganizacao,
  } from "@/types/gerais"
  import { usarManipuladorObjetos } from "@/composable/UsarManipuladorObjetos/usarManipuladorObjetos"
  import { cancelamento } from "@/http/cancelar/cancelar.services"
  import Button from "primevue/button"
  import { usarEscritorDeDados } from "@/composable/UsarEscritorDeDados/usarEscritorDeDados"
  import { usarMensagemUsuario } from "@/composable/UsarMensagemUsuario/usarMensagemUsuario"
  import { useI18n } from "vue-i18n"
  import { usarPermissionamento } from "@/composable/UsarPermissionamento"

  type DadosDoModal = {
    conteudo: string
    cabecalho: string
    cancelar: {
      acao: () => void
      texto: string
    }
    confirmar: {
      acao: () => void
      texto: string
    }
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'TProjetos',
  setup(__props) {

  const { t } = useI18n()

  const gruposDeProjetosRepositorio = new GruposDeProjetosRepositorio()
  const { leitor } = usarLeitorDeDados()
  const { escritor, resolver } = usarEscritorDeDados()
  const { buscarMaisDados } = usarBuscarMaisDados()
  const { colher } = usarManipuladorObjetos()
  const { onErro, onAviso } = usarMensagemUsuario()
  const router = useRouter()

  const leitorGruposDeProjetos = leitor<
    ListarGruposDeProjetos,
    ParametrosGruposDeProjetos
  >(gruposDeProjetosRepositorio.listarGruposDeProjetosFrontend, {
    ativo: "igual.true",
    "por-pagina": 30,
  })

  const escritorDeletarGrupoDeProjetos = escritor<{ id: string }, string>(
    gruposDeProjetosRepositorio.deletarGrupoDeProjetos
  )

  const rotaBase = ref<MenuItem>({
    label: t("projetos"),
    icon: "pi pi-map",
    to: "/projetos",
  })

  const breadCrumbItems = ref<MenuItem[]>([])
  const grupoSelecionado = ref<GrupoDeProjetos | null>(null)
  const gruposDeProjetos = ref<ListarGruposDeProjetos[]>([])
  const podeVisualizarListaDeGrupos = ref<boolean>(false)
  const idGrupoSelecionado = ref<string>("")
  const idGrupoEmEdicao = ref<string | null>(null)
  const mostrarModalDeAlerta = ref<boolean>(false)
  const estaProcessandoAcaoModalAviso = ref<boolean>(false)
  const usuarioTemPermissaoDeEdicao = ref<boolean>(false)
  const tabelaProjetosRef = ref<InstanceType<typeof OTabelaProjetos> | null>()
  const dadosDoModal = reactive<DadosDoModal>({
    conteudo: "",
    cabecalho: "",
    cancelar: {
      acao: () => void 0,
      texto: "",
    },
    confirmar: {
      acao: () => void 0,
      texto: "",
    },
  })

  const estaEmModoEdicao = computed(() => !!idGrupoEmEdicao.value)


  const possuiGrupoSelecionado = computed(() => !!grupoSelecionado.value)

  const entidadeGruposDeProjetos = computed(() => {
    return colher<ListarGruposDeProjetos, EntidadeSimples>(
      gruposDeProjetos.value,
      ["id", "nome"]
    )
  })

  const usuarioEhResponsavelPorAlgumGrupo = computed(() => {
    return gruposDeProjetos.value.length !== 0
  })

  const buscarGruposDeProjetos = async (): Promise<void> => {
    await leitorGruposDeProjetos.executar()

    const resultadoDaRequisicao = leitorGruposDeProjetos.resultado

    if (resultadoDaRequisicao.status === "sucesso") {
      gruposDeProjetos.value = resultadoDaRequisicao.dados
    } else if (resultadoDaRequisicao.status === "vazio") {
      gruposDeProjetos.value = []
    } else if (resultadoDaRequisicao.status === "erro") {
      onErro({
        resumo: t("naoFoiPossivelBuscarOsGruposDeProjetos"),
        detalhes: resultadoDaRequisicao.mensagem,
      })
    }
  }

  const buscarMaisGrupos = async (): Promise<void> => {
    await buscarMaisDados(leitorGruposDeProjetos, gruposDeProjetos)
  }

  const { verificarPermissao: permissaoProjetos } =
    usarPermissionamento("Projetos")

  const definirPermissaoDeEdicaoDeGrupos = (): boolean => {
    return permissaoProjetos("editar")
  }

  const definirModoDeVisualizacaoPorPermissao = (): boolean => {
    buscarPorTodosOsProjetos()
    return true
  }

  const definirItensNaTabelaPorGrupo = (idGrupo: string): void => {
    idGrupoSelecionado.value = idGrupo
    grupoSelecionado.value = gruposDeProjetos.value.find(
      (grupo) => grupo.id === idGrupo
    ) as GrupoDeProjetos

    usuarioTemPermissaoDeEdicao.value = definirPermissaoDeEdicaoDeGrupos()

    breadCrumbItems.value = [
      {
        label: grupoSelecionado.value.nome,
        to: `/projetos`,
      },
    ]
  }

  const definirVisualizacaoComTodosItens = (): void => {
    grupoSelecionado.value = null
    idGrupoSelecionado.value = "sem-grupo"

    breadCrumbItems.value = [
      {
        label: t("todosOsProjetos"),
        to: `/projetos`,
      },
    ]
  }

  const setarModalDeCancelar = (): void => {
    dadosDoModal.cancelar.acao = definirEstadoModalDeletarGrupoDeProjeto
    dadosDoModal.confirmar.acao = deletarGrupoDeProjeto
    dadosDoModal.cancelar.texto = t("cancelar")
    dadosDoModal.confirmar.texto = t("deletar")
    dadosDoModal.cabecalho = t("deletarGrupoDeProjetos")
    dadosDoModal.conteudo = t("apenasGrupoSeraDeletado")
  }

  const setarModalDeTrocaDeGrupo = (idEmEdicao: string): void => {
    const sairDoModoDeEdicao = (): void => {
      idGrupoEmEdicao.value = null
      mostrarModalDeAlerta.value = false
      definirVisualizacaoDeGrupos(idGrupoSelecionado.value)
    }

    const fecharModalDeAlerta = (idSendoEditado: string): void => {
      mostrarModalDeAlerta.value = false

      definirItensNaTabelaPorGrupo(idSendoEditado)
    }

    mostrarModalDeAlerta.value = true
    dadosDoModal.cancelar.acao = () => fecharModalDeAlerta(idEmEdicao)
    dadosDoModal.confirmar.acao = () => sairDoModoDeEdicao()
    dadosDoModal.cancelar.texto = t("voltarEditar")
    dadosDoModal.confirmar.texto = t("simCancelar")
    dadosDoModal.cabecalho = t("cancelarEdicaoDoGrupoDeProjetos")
    dadosDoModal.conteudo = t("aoCancelarEdicaoAsAlteracoesFeitasNoGrupoSeraoPerdidas")
  }

  const buscarPorTodosOsProjetos = (): boolean => {
    definirVisualizacaoComTodosItens()
    return true
  }

  const definirEstadoModalDeletarGrupoDeProjeto = (): void => {
    setarModalDeCancelar()
    mostrarModalDeAlerta.value = !mostrarModalDeAlerta.value
  }

  const deletarGrupoDeProjeto = async (): Promise<void> => {
    try {
      const grupoSelecionadoEhInvalido =
        !idGrupoSelecionado.value || idGrupoSelecionado.value === "sem-grupo"
      if (grupoSelecionadoEhInvalido) {
        throw new Error(t("naoFoiPossivelDeletarGrupoDeProjetos"))
      }

      estaProcessandoAcaoModalAviso.value = true

      escritorDeletarGrupoDeProjetos.mudarArgumentos([
        idGrupoSelecionado.value,
      ])
      await escritorDeletarGrupoDeProjetos.executar()

      resolver(escritorDeletarGrupoDeProjetos.resultado, {
        sucesso: async () => {
          idGrupoSelecionado.value = "sem-grupo"
          await montarGruposEProjetos()
          onAviso({
            resumo: t("grupoDeProjetosDeletados"),
            detalhes: t("vejaSeusProjetosEm"),
          })
        },
        erro(resultado) {
          throw new Error(resultado.mensagem)
        },
      })
    } catch (erro: any) {
      onErro({
        resumo: t("naoFoiPossivelDeletarGrupoDeProjetos"),
        detalhes: erro.message,
      })
    } finally {
      definirEstadoModalDeletarGrupoDeProjeto()
      estaProcessandoAcaoModalAviso.value = false
    }
  }

  const irParaCriarProjeto = (): void => {
    router.push("/novo-projeto")
  }

  const irParaCriarGrupo = (): void => {
    router.push("/novo-grupo")
  }

  const alternarEntreVisualizacaoEdicao = (): void => {
    idGrupoEmEdicao.value = idGrupoSelecionado.value
  }

  const sairDoModoEdicao = async (): Promise<void> => {
    idGrupoEmEdicao.value = null
    buscarProjetos(idGrupoSelecionado.value)
  }

  const buscarProjetos = async (
    idGrupo: Anulavel<string> = null
  ): Promise<void> => {
    await tabelaProjetosRef.value?.lidarComBuscaDeProjetos(idGrupo)
  }

  const sairDoModoEdicaoEAtualizar = async (): Promise<void> => {
    const idGrupoDeRetorno = idGrupoEmEdicao.value as string
    idGrupoEmEdicao.value = null
    await Promise.allSettled([
      buscarGruposDeProjetos(),
      buscarProjetos(idGrupoDeRetorno),
    ])
    definirItensNaTabelaPorGrupo(idGrupoDeRetorno)
  }

  const montarGruposEProjetos = async (): Promise<void> => {
    await buscarGruposDeProjetos()
    podeVisualizarListaDeGrupos.value = definirModoDeVisualizacaoPorPermissao()
  }

  const definirVisualizacaoDeGrupos = async (
    idGrupo: string
  ): Promise<void> => {
    if (estaEmModoEdicao.value) {
      setarModalDeTrocaDeGrupo(idGrupoEmEdicao.value!)
      return
    }

    buscarProjetos(idGrupo)

    if (idGrupo === "sem-grupo") {
      definirVisualizacaoComTodosItens()
    } else {
      definirItensNaTabelaPorGrupo(idGrupo)
    }
  }

  watch(idGrupoSelecionado, (idGrupo: string, idAntigo: string) => {
    const estaIndoParaItemJaEmEdicao = idGrupo === idGrupoEmEdicao.value
    const ehTrocaDeGrupo = idGrupo !== idAntigo && !!idAntigo
    if (estaIndoParaItemJaEmEdicao) {
      return
    }

    if (ehTrocaDeGrupo) {
      cancelamento.cancelarRequisicoesPendentes()
    }

    definirVisualizacaoDeGrupos(idGrupo)
  })

  onMounted(async () => {
    await montarGruposEProjetos()
  })

return (_ctx: any,_cache: any) => {
  const _component_PButton = _resolveComponent("PButton")!
  const _directive_permissionamento = _resolveDirective("permissionamento")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(OTrilhaDeNavegacao), {
          "inicio-da-trilha": rotaBase.value,
          "itens-da-trilha": breadCrumbItems.value
        }, null, 8, ["inicio-da-trilha", "itens-da-trilha"]),
        (!_unref(estaEmModoEdicao))
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _withDirectives(_createVNode(_component_PButton, {
                onClick: irParaCriarGrupo,
                class: "TProjetos__BotaoCriarGrupo p-button-blue",
                "data-testid": "TProjetos__BotaoCriarGrupo",
                label: _unref(t)('criarGrupo')
              }, null, 8, ["label"]), [
                [_directive_permissionamento, { operacao: 'criar' }, "Projetos"]
              ]),
              _withDirectives(_createVNode(_component_PButton, {
                onClick: irParaCriarProjeto,
                class: "TProjetos__BotaoCriarProjeto p-button-warning",
                "data-testid": "TProjetos__BotaoCriarProjeto",
                label: _unref(t)('criarProjeto')
              }, null, 8, ["label"]), [
                [_directive_permissionamento, { operacao: 'criar' }, "Projetos"]
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_4, [
        (podeVisualizarListaDeGrupos.value && _unref(usuarioEhResponsavelPorAlgumGrupo))
          ? (_openBlock(), _createBlock(_unref(MListaDeGrupos), {
              key: 0,
              "id-item-selecionado": idGrupoSelecionado.value,
              "onUpdate:id-item-selecionado": _cache[0] || (_cache[0] = ($event: any) => ((idGrupoSelecionado).value = $event)),
              "buscar-mais-itens": buscarMaisGrupos,
              itens: _unref(entidadeGruposDeProjetos)
            }, null, 8, ["id-item-selecionado", "itens"]))
          : _createCommentVNode("", true),
        (_unref(estaEmModoEdicao) && !!grupoSelecionado.value)
          ? (_openBlock(), _createBlock(_unref(OEditarGrupos), {
              key: 1,
              onVoltarParaVisualizacao: sairDoModoEdicao,
              onVoltarParaVisualizacaoEAtualizar: sairDoModoEdicaoEAtualizar,
              class: "TProjetos__Tabela",
              "data-testid": "TProjetos__ModoDeEdicaoGrupo",
              "id-grupo": grupoSelecionado.value.id,
              nome: grupoSelecionado.value.nome,
              "projetos-pre-selecionados": grupoSelecionado.value.projetos,
              "usuarios-responsaveis": grupoSelecionado.value.usuariosResponsaveis
            }, null, 8, ["id-grupo", "nome", "projetos-pre-selecionados", "usuarios-responsaveis"]))
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("div", _hoisted_5, [
          (_unref(possuiGrupoSelecionado))
            ? (_openBlock(), _createBlock(_unref(MCabecalhoTabelaGrupo), {
                key: 0,
                onAoDeletarGrupo: definirEstadoModalDeletarGrupoDeProjeto,
                onAoEditarGrupo: alternarEntreVisualizacaoEdicao,
                "nome-do-grupo": grupoSelecionado.value!.nome,
                "permissao-de-edicao": usuarioTemPermissaoDeEdicao.value,
                "usuarios-responsaveis": grupoSelecionado.value!.usuariosResponsaveis
              }, null, 8, ["nome-do-grupo", "permissao-de-edicao", "usuarios-responsaveis"]))
            : _createCommentVNode("", true),
          _createVNode(_unref(OTabelaProjetos), {
            ref_key: "tabelaProjetosRef",
            ref: tabelaProjetosRef,
            "id-grupo-de-projetos": idGrupoSelecionado.value
          }, null, 8, ["id-grupo-de-projetos"])
        ], 512), [
          [_vShow, !_unref(estaEmModoEdicao)]
        ])
      ])
    ]),
    _createVNode(_unref(MModalDeAlerta), {
      cabecalho: dadosDoModal.cabecalho,
      class: "TProjetos__ModalDeAlerta",
      "data-testid": "TProjetos__ModalDeAlerta",
      fechavel: false,
      "model-value": mostrarModalDeAlerta.value
    }, {
      conteudo: _withCtx(() => [
        _createElementVNode("p", _hoisted_6, _toDisplayString(dadosDoModal.conteudo), 1)
      ]),
      acoes: _withCtx(() => [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_unref(Button), {
            onClick: dadosDoModal.cancelar.acao,
            class: "ModalDeAlerta__BotaoCancelar",
            "data-testid": "ModalDeAlerta__BotaoCancelar",
            disabled: estaProcessandoAcaoModalAviso.value,
            label: dadosDoModal.cancelar.texto,
            outlined: ""
          }, null, 8, ["onClick", "disabled", "label"]),
          _createVNode(_unref(Button), {
            onClick: dadosDoModal.confirmar.acao,
            class: "ModalDeAlerta__BotaoConfirmar",
            "data-testid": "ModalDeAlerta__BotaoConfirmar",
            disabled: estaProcessandoAcaoModalAviso.value,
            label: dadosDoModal.confirmar.texto,
            loading: estaProcessandoAcaoModalAviso.value,
            outlined: ""
          }, null, 8, ["onClick", "disabled", "label", "loading"])
        ])
      ]),
      _: 1
    }, 8, ["cabecalho", "model-value"])
  ], 64))
}
}

})